module.exports = __webpack_public_path__ + "5f00af1c7cc314117221a1dfea28d36d.png";